import http from '@/utils/http';

/**
 * 查询用户管理的所有组织-pz
 */
export function getManageOrgList(data) {
    return http({
        url: '/api-lcrm/lcrm/org/info/selectByCondition',
        method: 'post',
        data
    });
};

/**
 * 交接主表-保存-tr
 */
export function saveDraftOpera(data) {
    return http({
        url: '/api-lcrm/asset/transfer/save',
        method: 'post',
        data
    });
};

/**
 * 提交审批-tr
 */
export function submitApproval(data) {
    return http({
        url: '/api-lcrm/asset/transfer/flow/submit',
        method: 'post',
        data
    });
};

/**
 * 导出
 */
export function reportExport(data) {
    return http({
        url: '/api-lcp-report/report/task/export',
        method: 'post',
        data
    });
};

/**
 * 资产交接列表-tr
 */
export function getList(data) {
    return http({
        url: '/api-lcrm/asset/transfer/pageList',
        method: 'post',
        data
    });
};

/**
 * 资产交接详情-tr
 */
export function getDetailByCode(data) {
    return http({
        url: '/api-lcrm/asset/transfer/detailByCode',
        method: 'get',
        params: data
    });
};

/**
 * 资产交接列表-删除-tr
 */
export function deleteApi(data) {
    return http({
        url: '/api-lcrm/asset/transfer/deleteBatch',
        method: 'post',
        data
    });
};

/**
 * 资产交接流程-校验-tr
 */
export function checkVerityApi(data) {
    return http({
        url: '/api-lcrm/asset/transfer/flow/save/verify',
        method: 'get',
        params: data
    });
};
